// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Yyh08{height:100%;width:100%;background-color:#eaeaef}.BCs3w{max-width:752px}.f36jF .BCs3w{width:100%}.p6aSf{display:contents}.p6aSf.w89Ft{display:flex;flex-direction:row;justify-content:center;width:100%;box-sizing:border-box;transition:padding-right 250ms ease-in-out}.p6aSf.w89Ft .BCs3w{flex:0 1 auto}.p6aSf.w89Ft.ot8x0{padding-right:514px}@media(prefers-reduced-motion: reduce){.p6aSf.w89Ft{transition:none}}.uxCPq{margin:16px}.PUd05{display:flex;justify-content:center}.W7oH5{display:flex;justify-content:center}.pd5dE{display:flex;flex-direction:column;align-items:center;padding-top:40px;padding-bottom:24px;overflow-y:auto;overflow-x:hidden;height:100%;max-width:100%}.kT6ku{margin-block-end:20px}.HNaf_{width:24px;flex-shrink:0;color:#6942f8}.uzT70{min-block-size:1px;min-inline-size:100%;margin-block:32px;background-color:#eaeaef}.uzT70.Fjfjz{min-block-size:0px;margin-block:24px}.SXzFT{gap:12px}.SXzFT:not(:last-child){margin-block-end:20px}.Y2hsZ{display:flex;align-items:center;gap:8px}.aeDNh{display:flex;align-items:center;gap:8px;margin-inline-start:28px;margin-block-start:8px}.zuYva{display:flex;flex-direction:row;gap:8px}.HP3Oh{display:flex;align-items:center;gap:8px;max-block-size:100%}.sjvAG{color:#089475}.CqmE8{color:#eb7272}.DcFKy{display:flex;flex-direction:column;gap:20px;margin-top:20px}.JDf2n{min-width:100px !important}.IjSix{min-inline-size:fit-content !important}._nRgm{z-index:1500}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"mainContainer": `Yyh08`,
	"cardsContainer": `BCs3w`,
	"mobile": `f36jF`,
	"studioLayout": `p6aSf`,
	"withPane": `w89Ft`,
	"isOpen": `ot8x0`,
	"previewModalContent": `uxCPq`,
	"previewModalHeader": `PUd05`,
	"previewModalFooter": `W7oH5`,
	"agreementStudio": `pd5dE`,
	"marginBottom": `kT6ku`,
	"infoIcon": `HNaf_`,
	"innerSeparator": `uzT70`,
	"thin": `Fjfjz`,
	"radio": `SXzFT`,
	"pauseServiceSelector": `Y2hsZ`,
	"requestAccountantAccess": `aeDNh`,
	"modalHeader": `zuYva`,
	"statusContainer": `HP3Oh`,
	"checkmarkContainer": `sjvAG`,
	"savingError": `CqmE8`,
	"checkboxWrapper": `DcFKy`,
	"submitBtn": `JDf2n`,
	"fitContentBtn": `IjSix`,
	"popper": `_nRgm`
};
export default ___CSS_LOADER_EXPORT___;
